import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {SubscribersService, ToastService, TokenStorageService} from '@coreServices';
import {ApiConstants, CommonConstants, ROUTES} from '@coreConstant';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorageService = inject(TokenStorageService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const subscriberService = inject(SubscribersService);

  const url = router.url;
  const paths = ['/account', '/gather-commitment', 'price-list', '/checkout'];
  const isTokenReuired = paths.some(route => url.startsWith(route));
  const reqUrl = req.url
  req = req.clone({
    url: environment.API_URL + req.url
  });

  const guestURLs = [
    'quote-order/detail', 'quote-order/track-order-detail', 'quote-order/download-by-export-id', 'quote-order/share-by-export-id', 'quote-order/share-by-tracking-id',
    'product-collection', 'quote-order/update-delivery-address-by-export-id', 'quote-order/update-delivery-address-by-tracking-id',
    'quote-order/update-status-on-address-change-by-export-id', 'quote-order/update-stock-required-date-by-export-id', 'quote-order/update-stock-required-date-by-tracking-id',
    'quote-order/update-by-export-id', 'quote-order/update-by-tracking-id', 'quote-product-applied-calculator/create-by-export-id', 'quote-order/re-calculate-quote-price-by-export-id',
    'quote-product-applied-calculator/delete-by-export-id','quote-order/check-export-id', 'account/get-by-abn'
  ];
  if (isTokenReuired) {
    if (!guestURLs.some(route => reqUrl.startsWith(route))) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenStorageService.getToken()}`
        },
      });
    }
  } else {
    const authURLs = ['oauth/login-user', 'account', 'quote-order', 'quote-product', 'favorite-product', 'product/download-collection-size-table', 'product/download-price-table', 'contact', 'user/change-password'];
    if (tokenStorageService.getToken()) {
      authURLs.push('product');
    }
    if (authURLs.some(route => reqUrl.startsWith(route)) && !guestURLs.some(route => reqUrl.startsWith(route)) && tokenStorageService.getToken()) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenStorageService.getToken()}`
        },
      });
    }
  }

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          toastService.showError(err.error['message'] || err.error['data']['message'])
          tokenStorageService.clearStorage();
          subscriberService.isUserLoggedIn.next(false);
        } else if (err.status === 500) {
          toastService.showError(CommonConstants.INTERNAL_SERVER_ERROR);
        } else {
          if (err && err.error && err.error['message']) toastService.showError(err.error['message'])
        }
      }
      return throwError(() => err);
    })
  );
};
